import { H6 } from "@sellar-io/components";
import { useMediaQuery } from "usehooks-ts";
import { useShallow } from "zustand/react/shallow";

import { DiscoveryFilterButton } from "../components/DiscoveryFilterButton";
import { FilterDrawerHeader } from "../components/DiscoveryMobileFilterDrawer";
import {
  dietaryTypes,
  dietaryTypeValues,
  useDiscoveryV2SearchStore,
} from "../DiscoveryV2SearchStore";
import { CollapsableFilterCard } from "./FilterCard";

export const FilterDietaryCard = ({ onClick }: { onClick?: () => void }) => {
  const isDesktop = useMediaQuery("(min-width: 1084px)");
  const { selectedDietaryTypes, removeDietaryType, addDietaryType } =
    useDiscoveryV2SearchStore(
      useShallow((state) => ({
        selectedDietaryTypes: state.selectedDietaryTypes,
        addDietaryType: state.addDietaryType,
        removeDietaryType: state.removeDietaryType,
      })),
    );

  const onItemClick = (dietaryType: "lactoseFree" | "vegan" | "glutenFree") => {
    if (selectedDietaryTypes.includes(dietaryType)) {
      return removeDietaryType(dietaryType);
    }
    addDietaryType(dietaryType);
  };
  return (
    <>
      {isDesktop ? (
        <CollapsableFilterCard header={<H6>Dietary</H6>}>
          {dietaryTypeValues.map((dietaryType) => (
            <DiscoveryFilterButton
              key={dietaryType}
              title={dietaryTypes[dietaryType]}
              selected={selectedDietaryTypes.includes(dietaryType)}
              onClick={() => onItemClick(dietaryType)}
            />
          ))}
        </CollapsableFilterCard>
      ) : (
        <div className={"flex flex-col"}>
          <FilterDrawerHeader title={"Dietary"} onClick={onClick} />
          <div className={"mt-4 flex flex-col gap-1 p-4"}>
            {dietaryTypeValues.map((dietaryType) => (
              <DiscoveryFilterButton
                key={dietaryType}
                selected={selectedDietaryTypes.includes(dietaryType)}
                onClick={() => onItemClick(dietaryType)}
                title={dietaryTypes[dietaryType]}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
